module.exports = __webpack_public_path__ + "img/JS-logo.3d9ff557.svg";